import Badge from '../../ui/Badge';
import type { BadgeVariant } from '../../ui/Badge';
import type { AuiRendererProps } from '../registry';

export function AuiBadge({ node }: AuiRendererProps) {
  const props = node.component.props ?? {};
  const text = (props.text as string) ?? '';
  const variant = (props.variant as BadgeVariant) ?? 'gray';

  return (
    <span data-testid="aui-badge">
      <Badge variant={variant}>
        {text}
      </Badge>
    </span>
  );
}
